/**
 * @generated SignedSource<<a52ab06cae79baa393f942e2c05e0a5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MsRemoveTenantInput = {
  clientMutationId?: string | null | undefined;
  remove?: boolean | null | undefined;
};
export type Integration_MicrosoftRemoveAuth_Mutation$variables = {
  input: MsRemoveTenantInput;
};
export type Integration_MicrosoftRemoveAuth_Mutation$data = {
  readonly msRemoveTenant: {
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type Integration_MicrosoftRemoveAuth_Mutation = {
  response: Integration_MicrosoftRemoveAuth_Mutation$data;
  variables: Integration_MicrosoftRemoveAuth_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MsRemoveTenantPayload",
    "kind": "LinkedField",
    "name": "msRemoveTenant",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_MicrosoftRemoveAuth_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Integration_MicrosoftRemoveAuth_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7a86d12a21e92a410e87d8f093fbba94",
    "id": null,
    "metadata": {},
    "name": "Integration_MicrosoftRemoveAuth_Mutation",
    "operationKind": "mutation",
    "text": "mutation Integration_MicrosoftRemoveAuth_Mutation(\n  $input: MsRemoveTenantInput!\n) {\n  msRemoveTenant(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "4e45cda51649743b09f02735e3e7c84d";

export default node;
